var Utils = require('./Utils');

function RegisterForm(config,data){
    var self = this;
    self.inner = function () {};
    self.fn = function () {};

    self.inner.utils = config.utils != null ? config.utils: new Utils();
    self.inner.apiClient = self.inner.utils.getApiClient(config);

    self.inner.initialized = ko.observable(false);

    self.id = ko.observable();

    self.form = config.form;

    self.purchase_type = ko.observable().extend({
        required: {
            params: true,
            message: 'Please choose a type of purchase',
        }
    });

    self.inner.order_required = ko.computed(function(){
        return self.purchase_type() != 'No Purchase Made';
    });

    self.order_number = ko.observable().extend({
       required:{
           params: true,
           message: 'Please enter the order number',
           onlyIf: self.inner.order_required

       }
    });

    self.first_name = ko.observable().extend({
        required: {
            params: true,
            message: 'Please enter first name'
        }
    });

    self.last_name = ko.observable().extend({
        required: {
            params: true,
            message: 'Please enter last name'
        }
    });

    self.address = ko.observable().extend({
        required: {
            params: true,
            message: 'Please enter address'
        }
    });
    self.address2 = ko.observable();
    self.city = ko.observable().extend({
        required:{
            params: true,
            message: 'Please enter a city'
        }
    });
    self.state = ko.observable().extend({
        required:{
            params: true,
            message: 'Please select a state',
            onlyIf: self.inner.initialized
        }
    });
    self.zip_code = ko.observable().extend({
        required:{
            params: true,
            message: 'Please enter a zip code'
        }
    });

    self.dog_name = ko.observable().extend({
        required:{
            params: true,
            message: "Please enter dog's name"
        }
    });

    self.dog_type = ko.observable().extend({
        required:{
            params: true,
            message: "Please enter type of dog",
            onlyIf: self.inner.initialized
        }
    });
    self.dog_status = ko.observable().extend({
        required:{
            params: true,
            message: "Please select status of dog",
            onlyIf: self.inner.initialized
        }
    });

    self.dog_dob = ko.observable().extend({
        required:{
            params: true,
            message: "Please enter dog's date of birth"
        }
    });

    self.phone = ko.observable();
    self.comment = ko.observable();
    self.email = ko.observable();

    self.dont_list_address = ko.observable(false);
    self.dont_list_phone = ko.observable(false);

    self.comments = ko.observable();

    self.inner.processing = ko.observable(false);


    self.inner.url = {
        save_form: config.url.save_form,
        save_photos: config.url.save_photos
    }

    self.dog_image = ko.observable().extend({
        required: {
            params: true,
            message: "Please add a photo for the dog"
        }
    });
    self.handler_image = ko.observable();

    self.fn.dogImageChanged = function(data,event){
        var file = event.currentTarget.files[0];
        self.dog_image(file != null ? true : null);
    }
    self.fn.handlerImageChanged = function(data,event){
        var file = event.currentTarget.files[0];
        self.handler_image(file != null ? true : null);
    }

    self.errors = null;

    self.fn.validateForm = function(){
        if(self.errors == null) {
            self.inner.initialized(true);
            self.errors = ko.validation.group(self);
        }

        var valid = self.errors().length == 0;

        if(!valid){
            self.errors.showAllMessages();
            $(document).trigger('scroll-to-error');
        }

        return valid;
    };


    self.fn.saveForm = function(){
        if(!self.fn.validateForm())
            return;

        self.inner.processing(true);
        var data = {
            id: self.id(),
            purchase_type: self.purchase_type(),
            order_number: self.order_number(),
            first_name: self.first_name(),
            last_name: self.last_name(),
            email: self.email(),
            dog_name: self.dog_name(),
            dog_type: self.dog_type(),
            dog_status: self.dog_status(),
            dog_dob: self.dog_dob(),
            address: self.address(),
            address2: self.address2(),
            city: self.city(),
            state: self.state(),
            zip_code: self.zip_code(),
            phone: self.phone(),
            dont_list_address: self.dont_list_address(),
            dont_list_phone: self.dont_list_phone(),
            comments: self.comments()
        };

        var formData = self.fn.getFormData(data);

        self.inner.apiClient.call(self.inner.url.save_form,formData,function(response){
            if(response.success){
               $(document).trigger('form-saved');
            }
            else{
                self.inner.utils.alert(response.message,'error');
                self.inner.processing(false);
            }
        },function(e){
            self.inner.utils.alert('Error occurred while saving form','error');
            self.inner.processing(false);
        },'POST');
    }

    self.fn.getFormData = function(data){
        for(var i in data){
            var value = data[i];
            var input = self.form.find('input[name="'+i+'"]');

            if(input.length == 0){
                input = $('<input>').attr('type','hidden').attr('name',i).attr('id',i).appendTo(self.form);
            }
            input.val(value);
        }
        return new FormData(self.form[0]);
    }
}

module.exports = RegisterForm;
